// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1xAZB","actions":"GroupTable_actions__2pbNy","deleteModalFooter":"GroupTable_deleteModalFooter__3KECA"};